/**
 * UniHawk Global YouTube testimonial playlist (student & parent stories).
 * Playlist: https://www.youtube.com/playlist?list=PLi1XFPmQU_IZATozPr5ixmbhe8bWHJbfd
 * To refresh: fetch https://www.youtube.com/feeds/videos.xml?playlist_id=PLi1XFPmQU_IZATozPr5ixmbhe8bWHJbfd
 */

export const VIDEO_TESTIMONIALS_PLAYLIST_ID = "PLi1XFPmQU_IZATozPr5ixmbhe8bWHJbfd";

export const VIDEO_TESTIMONIALS = {
  title: "Real students.",
  highlight: "Real stories.",
  intro:
    "Hear from students and families who explored careers, built projects, and found their path—with mentors who’ve been there.",
  playlistUrl: `https://www.youtube.com/playlist?list=${VIDEO_TESTIMONIALS_PLAYLIST_ID}`,
  playlistLabel: "Watch more on YouTube",
  videos: [
    {
      id: "josh",
      youtubeId: "pfVBBSh-Frk",
      name: "Josh",
      line: "His journey to international education with UniHawk",
    },
    {
      id: "radhika",
      youtubeId: "d78zkb7UAvI",
      name: "Radhika Prabhu",
      line: "From STEM exploration to engineering",
    },
    {
      id: "hope",
      youtubeId: "FSP3o_h_nEQ",
      name: "UniHawk student",
      line: "How one future can inspire a generation",
    },
    {
      id: "zara",
      youtubeId: "Svm_xJ9Lun4",
      name: "Zara",
      line: "Parsons NYC with scholarship",
    },
    {
      id: "prisha",
      youtubeId: "dOdjQHN65Q0",
      name: "Prisha",
      line: "Multiple medical school acceptances",
    },
    {
      id: "berklee",
      youtubeId: "6ofurbcB-9M",
      name: "Student success story",
      line: "From GEMS Wellington to Berklee College of Music",
    },
    {
      id: "toshit",
      youtubeId: "GY69lnPD85A",
      name: "Toshit",
      line: "A nurturing journey with UniHawk",
    },
    {
      id: "shlok",
      youtubeId: "8VywX8e6dFw",
      name: "Shlok",
      line: "UIUC & University of Manchester",
    },
    {
      id: "nidhi",
      youtubeId: "ZXph-Z9tMIM",
      name: "Nidhi",
      line: "UCLA Computer Science",
    },
    {
      id: "arjun",
      youtubeId: "EhCPoLK5oV0",
      name: "Arjun",
      line: "From Abu Dhabi to a top university",
    },
    {
      id: "abhinav",
      youtubeId: "e28rXdwrRkc",
      name: "Abhinav",
      line: "Aerospace engineering admission success",
    },
    {
      id: "thiya",
      youtubeId: "jnD8UePxfMs",
      name: "Thiya Jain",
      line: "Business studies at Cardiff University, UK",
    },
    {
      id: "christine",
      youtubeId: "1xI8J5KMRnE",
      name: "Christine",
      line: "DIA Dubai to UCL & King's College London",
    },
    {
      id: "vishal",
      youtubeId: "at66pIupje8",
      name: "Vishal",
      line: "Mechanical engineering admission",
    },
  ],
};
